import React from 'react';
import { Field } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import WithLabel, { LABEL_STYLES } from '../../../../components/with-label/WithLabel';
import WithError from '../../../../components/with-error/WithError';
import CommonTextarea from '../../../../components/common-textarea/CommonTextarea';
import { Input } from '../../../../components/common-inputs';

import scss from '../NameSection.module.scss';

function GenieGoNameFormInner() {
  const { t } = useTranslation('projects');

  const isNameSectionLoading = useSelector((state) => state.projects.isNameSectionLoading);

  return (
    <>
      <Field name='brand' autoComplete='brand'>
        {({ input, meta }) => (
          <WithLabel variant={LABEL_STYLES.ALIGNED} label={t('brand')} maxWidth={360} isBold>
            <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
              <Input
                type='text'
                size='sm'
                isError={meta.touched && meta.error}
                formProps={input}
                disabled={isNameSectionLoading}
                autoComplete='brand'
              />
            </WithError>
          </WithLabel>
        )}
      </Field>

      <Field name='description' autoComplete='genie-go-description'>
        {({ meta, input }) => (
          <WithLabel variant={LABEL_STYLES.COLUMN} label={t('description')} isBold extraClassName={scss.inputRowLong}>
            <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
              <CommonTextarea
                name={input.name}
                value={input.value}
                onChange={input.onChange}
                onBlur={input.onBlur}
                onFocus={input.onFocus}
                autoComplete={input.autoComplete}
                isError={meta.touched && meta.error}
                disabled={isNameSectionLoading}
                rows='3'
                resize='none'
              />
            </WithError>
          </WithLabel>
        )}
      </Field>

      <Field name='referenceMessages' autoComplete='genie-go-reference-messages'>
        {({ meta, input }) => (
          <WithLabel
            variant={LABEL_STYLES.COLUMN}
            label={t('referenceMessages')}
            isBold
            extraClassName={scss.inputRowLong}>
            <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
              <CommonTextarea
                name={input.name}
                value={input.value}
                onChange={input.onChange}
                onBlur={input.onBlur}
                onFocus={input.onFocus}
                autoComplete={input.autoComplete}
                isError={meta.touched && meta.error}
                disabled={isNameSectionLoading}
                rows='5'
              />
            </WithError>
          </WithLabel>
        )}
      </Field>
    </>
  );
}

export default GenieGoNameFormInner;
